module.exports = __webpack_public_path__ + "img/plan-silver-plus.eecca2ba.svg";